/* eslint-disable no-multi-str */
import React from "react"
import SectionContainer from "../components/SectionContainer"
import SkillViewBuilder from "./SkillViewBuilder"

import javaLogo from "../images/javalogo.png"
import junitLogo from "../images/junitlogo.png"
import jfxLogo from "../images/fxlogo2.png"
import csharpLogo from "../images/csharplogo.png"
import cppLogo from "../images/cpplogo.png"
import rustLogo from "../images/rustlogo.png"
import wasmLogo from "../images/wasmlogo.png"

const skills = [
  {
    name: "Java",
    icon: javaLogo,
    proficiency: "Proficient",
    description: "Widely used object-oriented, cross-platform programming langugage",
    customtext: "I've used Java in academic environments to build large \
                scale user-oriented software. A good language to hone \
                object-oriented programming skills and apply good \
                software design & architecture principles.",
    related: [
      {
        name: "JUnit5",
        icon: junitLogo,
        proficiency: "Proficient",
      },
      {
        name: "JavaFX",
        icon: jfxLogo,
        proficiency: "Familiar",
      },
    ]
  },
  {
    name: "C#",
    icon: csharpLogo,
    proficiency: "Proficient",
    description: "General purpose programming language from Microsoft",
    customtext: "The only supported language of the popular game development \
                platform Unity. Syntactically similar to Java and easily \
                scales to large applications.",
  },
  {
    name: "C++",
    icon: cppLogo,
    proficiency: "Familiar",
    description: "Low level object-oriented programming language",
    customtext: "First programming language I learned in university. \
                More recently, I've experimented running C++ in browsers \
                by compiling to WebAssembly.",
    related: [
      {
        name: "WebAssembly",
        icon: wasmLogo,
        proficiency: "Familiar"
      }
    ]
  },
  {
    name: "Rust",
    icon: rustLogo,
    proficiency: "Familiar",
    description: "Modern systems programming language providing \
                  memory safety without garbage collection",
    customtext: "Rust has been voted the most beloved language \
                by the programming community for several years in \
                a row. I've started learning it so I can expand into \
                systems level programming. It also has a great \
                toolchain for WebAssembly.",
    related: [
      {
        name: "WebAssembly",
        icon: wasmLogo,
        proficiency: "Familiar"
      }
    ]
  },
]

const SoftwareSkills = () => (
  <SectionContainer header="Desktop & Systems">
    <SkillViewBuilder skills={skills} />
  </SectionContainer>
)

export default SoftwareSkills